import toast from '@/modules/toast/services';
import { toArray } from '@/utils';

export default {
  props: {
    allowNonPublished: Boolean,
  },
  mounted() {
    if (typeof this.filters === 'undefined') {
      throw new Error('allowed-contents-only mixin requires a `filters` attribute.');
    }
    this.updatePublishedFilter(this.allowNonPublished);
  },
  methods: {
    updatePublishedFilter(allowNonPublished) {
      if (allowNonPublished) {
        this.$delete(this.filters, 'state');
      } else {
        this.$set(this.filters, 'state', 'published');
      }
    },
    updateTypeFilter(types) {
      types = toArray(types);
      if (types.length === 0) {
        this.$delete(this.filters, 'type');
      } else {
        this.$set(this.filters, 'type', types);
      }
    },
    filterPublishedContents(content, notifyMessage = null) {
      if (this.allowNonPublished) {
        return content;
      }

      const isMultiple = Array.isArray(content);
      if (!isMultiple && !content) {
        return content;
      }

      const contents = toArray(content);
      // Strict comparation with `false` to avoid discard simple content cards,
      // where the `published` attribute is not defined.
      // @see https://mgr.bitban.com/issues/64069
      const filtered = contents.filter(c => c && c.published !== false);

      if (contents.length !== filtered.length) {
        if (notifyMessage) {
          toast.notify(notifyMessage);
        }
        return isMultiple ? filtered : filtered[0] || false;
      }
      return isMultiple ? filtered : filtered[0] || null;
    },
    filterContentsByType(content, notifyMessage = null) {
      const types = toArray(this.filters.type);
      const isMultiple = Array.isArray(content);
      if (types.length === 0
        || (!isMultiple && !content)) {
        return content;
      }

      const contents = toArray(content);
      const filtered = contents.filter(c => c && types.find(t => t === c.type));

      if (contents.length !== filtered.length) {
        if (notifyMessage) {
          toast.notify(notifyMessage);
        }
        return isMultiple ? filtered : filtered[0] || false;
      }
      return isMultiple ? filtered : filtered[0] || null;
    },
  },
  watch: {
    allowNonPublished(value) {
      this.updatePublishedFilter(value);
    },
  },
};
